import {
  PopupViewDispatchTypes,
  POPUP_VIEW_LOADING,
  POPUP_VIEW_SUCCESS,
} from "../actions/popupActionTypes";

interface PopupState {
  loading: boolean;
  popupView?: boolean;
}

const defaultState: PopupState = {
  loading: false,
};

const popupReducer = (
  state: PopupState = defaultState,
  action: PopupViewDispatchTypes
): PopupState => {
  switch (action.type) {
    case POPUP_VIEW_LOADING:
      return { ...state, loading: true };
    case POPUP_VIEW_SUCCESS:
      return { loading: false, popupView: action.payload };
    default:
      return state;
  }
};

export default popupReducer;
